import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StopInputContainer from './StopInputContainer';
import StopClusterMapContainer from './StopClusterMapContainer';
import LiveDepartureDisplayBoardContainer from './LiveDepartureDisplayBoardContainer';

export default class LiveDepartureContainer extends Component {
  render() {
    const { enableAccessibilityOutlines } = this.props;

    return (
      <div>
        <div className="main-content-container">
          <StopInputContainer />
          <LiveDepartureDisplayBoardContainer />
          <StopClusterMapContainer enableAccessibilityOutlines={enableAccessibilityOutlines} />
        </div>
      </div>
    );
  }
}

LiveDepartureContainer.propTypes = {
  enableAccessibilityOutlines: PropTypes.func,
};

LiveDepartureContainer.defaultProps = {
  enableAccessibilityOutlines: () => { /* default empty function */ },
};